import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-inline-flex align-center ga-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_property_value = _resolveComponent("ontos-property-value")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.named)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.value.dimension.name), 1))
      : _createCommentVNode("", true),
    (_ctx.value.related)
      ? (_openBlock(), _createBlock(_component_ontos_property_value, {
          key: 1,
          variant: "cell",
          property: _ctx.value.dimension.property,
          value: _ctx.value.related,
          context: _ctx.context,
          onLink: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('link', $event)))
        }, null, 8, ["property", "value", "context"]))
      : (_ctx.value.option)
        ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
            key: 2,
            option: _ctx.value.option,
            form: _ctx.formOf(_ctx.value.dimension)
          }, null, 8, ["option", "form"]))
        : _createCommentVNode("", true)
  ]))
}